// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".selectedFile[data-v-8a7cd672]{border:2px solid #ee7c4b}", ""]);
// Exports
module.exports = exports;
